// extracted by mini-css-extract-plugin
export default {"consumableReqsTable":"consumableReqsTable-Y7duW","text":"text-eJDI7","subtext":"subtext-hchxJ"};